import { Component, OnInit ,Renderer2 ,Inject ,HostListener} from '@angular/core';
import { AuthService } from '../services/index';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers:[AuthService]
})
export class NavbarComponent implements OnInit {
 
  scrWidth: number;


  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
       
        this.scrWidth = window.innerWidth;
        console.log(this.scrWidth);
        if(this.scrWidth<1000){
          this.toggel();
        }
        else{
          this.toggelin();
        }
  }

  clnm:string='';
  username:string='';
  aynm="";
 
  constructor(private Auth: AuthService,private router: Router, @Inject(DOCUMENT) private document: Document,
  private renderer: Renderer2) { 
 
   
  }

  ngOnInit(): void {
    this.clnm=localStorage.getItem('clnm');
    this.aynm=localStorage.getItem('aynm');
    this.username=localStorage.getItem('usrname');
    console.log("width",innerWidth);

   
    
  }
  clicklogout()
  {
    this.Auth.logout();
    this.router.navigate(['login']);

  }


  toggel(){
    this.renderer.addClass(this.document.body, 'ls-closed');
    this.document.getElementById("show").style.display="none";
    this.document.getElementById("close").style.display="block";
    
  }
  toggelin(){
    this.renderer.removeClass(this.document.body, 'ls-closed');
    // this.renderer.addClass(this.document.body, 'overlay-open');
    this.document.getElementById("show").style.display="block";
    this.document.getElementById("close").style.display="none";
    

  }
  onclicklogo()
  {
    this.router.navigate(['/app/home']);
  }

}
